<button *ngIf="selectedOption" mat-stroked-button (click)="select.open()" data-cy="borrower-status-picker" class="tw-w-full">
    <div class="column-grid tw-place-items-center tw-h-full">
      <mat-select
        [panelClass]="'!tw-max-h-[50vh]'"
        #select
        [value]="selectedOption"
        [disabled]="disabled"
        [matTooltip]="tooltip + '. ' + (disabledReason || '')"
        [matTooltipDisabled]="!disabledReason && !tooltip" matTooltipPosition="above">
        <mat-select-trigger class="column-grid tw-gap-2 tw-place-items-center tw-h-full">
          <span class="tw-rounded-full tw-bg-black tw-block tw-w-3 tw-h-3" [style.backgroundColor]="stageColor[selectedOption.stage]"></span>
          <span>{{ selectedOption.stage | titlecase }}:</span>
          <strong class="tw-pr-2">{{ selectedOption.label }}</strong>
        </mat-select-trigger>
        <mat-optgroup *ngFor="let group of groups" [label]="group.label | titlecase" [disabled]="group.disabled">
          <mat-option
            *ngFor="let option of group.options"
            [value]="option"
            [disabled]="option.value === selectedOption.value || option.disabledReason"
            [matTooltipDisabled]="!option.disabledReason"
            [matTooltip]="option.disabledReason"
            matTooltipPosition="above"
            (click)="handleSelectionChange(option)"
            [attr.data-cy]="'borrower-status-option-' + option.value">
            <div class="tw-flex tw-items-center tw-justify-between">
              <span>{{ option.label }}</span>
            </div>
          </mat-option>
        </mat-optgroup>
      </mat-select>
    </div>
</button>
